
import { DialogActions, IconButton, InputBase } from '@mui/material';
import CardServices from "../cardServices";
import { useEffect, useState } from "react";
import api from "../../../services/api";
import RegisterAccess from '../../../utils/registerAccess';
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import LoadingShort from "../../../load/loadingShort";
import { useNavigate } from "react-router-dom";
import MessageError from "../../../messages/messageError";
// import HeaderGestorConfigs from "../../../utils/headerGestorConfigs";
import { useSelector } from 'react-redux';

interface MenuState {
  solicitacoesAnalise: number;
  autorizadoAnaliseLaboratorial: number;
  analiseAmostra: number;
  analiseRelatorio: number;
  reclamacoes: number;
  analiseFinalizado: number;
  reprovado: number;
  farmacovigilancia: number;

  chefeArea: number;
  chefeDepartamento: number;
  directoraGeralAdjunta: number;
  directorGeral: number;
  certificadosEmitidos: number;
}
type MenuProps = {
  children?: React.ReactNode
}

export default function MenuControleQualidade({ children }: MenuProps) {
  const user = useSelector((state: any) => state.account.user);
  const navigate = useNavigate()

  const [menu, setMenu] = useState<MenuState>({
    solicitacoesAnalise: 0,
    autorizadoAnaliseLaboratorial: 0,
    analiseRelatorio: 0,
    analiseFinalizado: 0,
    reprovado: 0,

    reclamacoes: 0,
    farmacovigilancia: 0,

    analiseAmostra: 0,
    chefeArea: 0,
    chefeDepartamento: 0,
    directoraGeralAdjunta: 0,
    directorGeral: 0,
    certificadosEmitidos: 0,
  })
  const [loadMenu, setLoadMenu] = useState<boolean>(true);
  const [load, setLoad] = useState<boolean>(false);
  const [search, setSearch] = useState("");
  const [messageError, setMessageError] = useState("");
  const [analistaRevisor, setAnalistaRevisor] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoadMenu(true);

        // const userId = "664f25bf4cbfa53fb260b853";
        // const status = "Análise da Amostra";

        const [
          menuResponse,
          analistaResponse,
          // revisorResponse
        ] = await Promise.all([
          api.get("/menu/dcqmts"),
          api.get(`/avalicao-analiticas?revisorId=${user?._id}`)
          // api.get(`/avalicao-analiticas?analistaId=${userId}&status=`),
        ]);

        setMenu(menuResponse.data);

        // setAnalistaRevisor({
        //   ...analistaResponse.data.avaliacaoAnaliticas?.length,
        //   // ...revisorResponse.data.avaliacaoAnaliticas  
        // })
        setAnalistaRevisor(analistaResponse.data.avaliacaoAnaliticas?.length);

      } catch (error) {
        console.error("Erro ao carregar dados:", error);
      } finally {
        setLoadMenu(false);
      }
    };

    fetchData();
  }, []);

  const searchSolicitacao = async (e: any) => {
    e.preventDefault();
    setMessageError('')
    setLoad(true);

    try {
      const response = await api.post(`/solicitacao-analise/search-by-number`, {
        numero: search,
        // status: status, // 
      });
      // console.log(response)
      navigate(`/admin/dcqmts/gest/solicitacao-de-analise/${response.data.solicitacaoAnalise?._id}`)
    } catch (error) {
      // console.error(error);
      // setMessageError(error?.response?.data.message);
      setMessageError('Solicitação de analise não encontrada!');
    } finally {
      setLoad(false);
    }
  };

  return (
    <div className="tw-w-full">
      <RegisterAccess page={'menu controleQualidade'} />
      {messageError && <MessageError message={messageError} />}

      <DialogActions>
        <form
          onSubmit={searchSolicitacao}
          style={{
            width: '30%',
            border: "1px solid #85287e",
            borderRadius: 10,
            display: "flex",
            padding: 3,
            // flexWrap: "wrap",
            marginRight: 20,
          }}
        >
          <InputBase
            sx={{ ml: 1, flex: 1 }}
            // autoFocus
            type="number"
            placeholder="Procurar pelo  número de processo"
            inputProps={{ "aria-label": "Filtrar lista" }}
            onChange={(e) => setSearch(e.target.value)}
          />

          <IconButton type="submit" aria-label="search">
            {load ? <LoadingShort text={''} /> : <SearchOutlinedIcon />}
          </IconButton>
        </form>
      </DialogActions>

      <div className="tw-flex tw-flex-wrap tw-items-start tw-gap-5 tw-px-7 tw-py-4">
        <CardServices funcao='Técnico' load={loadMenu} count={menu.solicitacoesAnalise} icone={'/icones/controleQualidade/controloQualidade.svg'} nomeService={'Solicitaçōes de Análise '} link={'/admin/dcqmts/solicitacoes-de-analise/Análise'} />
        <CardServices funcao='' load={loadMenu} count={analistaRevisor} icone={'/icones/controleQualidade/analiseAmostraLaboratorioRelatorioAnalitico.svg'} nomeService={'Análise da Amostra no Laboratório'} link={'/admin/dcqmts/solicitacoes-de-analise/Análise da Amostra'} />
        <CardServices funcao='Técnico' load={loadMenu} count={menu.reprovado} icone={'/icones/solictacoesReprovadas.svg'} nomeService={'Solicitaçōes Reprovadas '} link={'/admin/dcqmts/solicitacoes-de-analise/Indeferido'} />
        {/* <CardServices load={loadMenu} count={menu.reclamacoes} icone={'/icones/Reclamacoes.svg'} nomeService={'Reclamações'} link={'/admin/reclamacoes?page=1'} /> */}
      </div>

      {/* <div className="tw-flex tw-flex-wrap tw-items-start tw-gap-5 tw-px-5 tw-py-4">
        <CardServices funcao='' load={loadMenu} count={menu.autorizadoAnaliseLaboratorial} icone={'/icones/chefeDepartamento.svg'} nomeService={'Autorização para Análise Laboratórial'} link={'/admin/dcqmts/solicitacoes-de-analise/Autorização para Análise Laboratorial'} />
        <CardServices funcao='' load={loadMenu} count={menu.analiseAmostra} icone={'/icones/controleQualidade/analiseAmostraLaboratorioRelatorioAnalitico.svg'} nomeService={'Análise da Amostra no Laboratório e Relatório Análitico'} link={'/admin/dcqmts/solicitacoes-de-analise/Análise da Amostra'} />
        <CardServices funcao='' load={loadMenu} count={menu.analiseRelatorio} icone={'/icones/controleQualidade/RevisaoRelatorioAnalitico.svg'} nomeService={'Revisão do Relatório Análitico'} link={'/admin/dcqmts/solicitacoes-de-analise/Análise do Relatório'} />
        <CardServices funcao='' load={loadMenu} count={menu.analiseFinalizado} icone={'/icones/controleQualidade/certificadosAutorizacoes.svg'} nomeService={'Certificados e Autorizações'} link={'/admin/dcqmts/solicitacoes-de-analise/Emissão da Autorização de Liberação de Lote'} />
      </div> */}

      <div className="tw-flex tw-flex-wrap tw-items-start tw-gap-7 tw-px-5 tw-py-4">
        <CardServices funcao='Chefe de Área' load={loadMenu} count={menu.chefeArea} icone={'/icones/chefedaSeccao.svg'} nomeService={'Chefe de Área'} link={'/admin/dcqmts/solicitacoes-de-analise/Chefe de Área'} />
        <CardServices funcao='Chefe de Departamento' load={loadMenu} count={menu.chefeDepartamento} icone={'/icones/chefeDepartamento.svg'} nomeService={'Chefe de Departamento'} link={'/admin/dcqmts/solicitacoes-de-analise/Chefe de Departamento'} />
        <CardServices load={loadMenu} count={menu.directoraGeralAdjunta} icone={'/icones/chefedaSeccao.svg'} nomeService={'Directora Geral Adjunta Servicos Executivos'} link={'/admin/dcqmts/solicitacoes-de-analise/Directora Geral Adjunta para os Serviços Executivos'} />
        <CardServices funcao='Director Geral' load={loadMenu} count={menu.directorGeral} icone={'/icones/diretoraGeral.svg'} nomeService={'Diretor(a) Geral'} link={'/admin/dcqmts/solicitacoes-de-analise/Director Geral'} />
        <CardServices funcao='' load={loadMenu} count={menu.certificadosEmitidos} icone={'/icones/controleQualidade/certificadosAutorizacoes.svg'} nomeService={'Certificados e Autorizações'} link={'/admin/dcqmts/solicitacoes-de-analise/Aprovado'} />
      </div>

      <div className="tw-flex tw-items-center tw-gap-2 tw-px-5 tw-pt-3 tw-pb-1 tw-border-t tw-border-gray-100">
        <div className="tw-w-0.5 tw-h-4 tw-bg-[#85287e]/40 tw-rounded-full" />
        <span className="tw-text-[11px] tw-font-semibold tw-tracking-widest tw-text-gray-400 tw-uppercase">Outros Serviços</span>
      </div>
      <div className="tw-flex tw-flex-wrap tw-items-start tw-gap-7 tw-px-5 tw-py-4">
        {children}
        <CardServices load={loadMenu} count={menu.farmacovigilancia} icone={'/icones/controleQualidade/solicitacoesAnalise.svg'} nomeService={'Farmacovigilância'} link={'/admin/farmacovigilancia/notificacoes/Controlo de Qualidade'} />
      </div>
    </div>
  )
}

